<template>
  <div>
    <el-button @click="toAddItems" type="primary" v-show="show">添加项目</el-button>
    <el-table :data="tableData" style="width: 100%" border show-summary id="items">
      <el-table-column label="纱支" width="180" prop="yarn"></el-table-column>
      <el-table-column label="颜色" width="100" prop="color">
        <template slot-scope="scope">
          <span v-if="scope.row.combine == '是'">{{scope.row.color}}*{{scope.row.combineColor}}</span>
          <span v-else>{{scope.row.color}}</span>
        </template>
      </el-table-column>
      <el-table-column label="色号" width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.combine == '是'">{{scope.row.colorNo}}*{{scope.row.combineColorNo}}</span>
          <span v-else>{{scope.row.colorNo}}</span>
        </template>
      </el-table-column>
      <el-table-column label="参照缸号" width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.combine == '是'">{{scope.row.demand}}*{{scope.row.combineDemand}}</span>
          <span v-else>{{scope.row.demand}}</span>
        </template>
      </el-table-column>
      <el-table-column label="订单数量(KG)" width="110" prop="itemQuantity"></el-table-column>
      <el-table-column label="投产数量(KG)" width="110" prop="productQuantity"></el-table-column>
      <el-table-column label="加工" width="180" prop="process"></el-table-column>
      <el-table-column label="单价" width="80" prop="unitPrice"></el-table-column>
      <!-- <el-table-column label="计价方式" width="100" prop="chargeMode"></el-table-column> -->
      <el-table-column label="价格小计" width="120" prop="price"></el-table-column>
      <el-table-column label="期望交期" prop="deliveryDate"></el-table-column>
      <el-table-column label="优先级" width="80" prop="priority" :formatter="priorityFormatter"></el-table-column>
      <el-table-column label="状态" width="100" prop="itemStatus"></el-table-column>
      <el-table-column label="操作" width="160" v-if="show">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="添加订单子项" :visible.sync="dialogFormVisible" :width="dialogWidth">
      <el-form :model="form" :label-width="formLabelWidth">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="纱支">
              <el-input v-model="form.yarn"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否并线">
              <el-select v-model="form.combine" placeholder="请选择是否并线">
                <el-option label="是" value="是"></el-option>
                <el-option label="否" value="否"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row>
          <el-col :span="8">
            <el-form-item label="颜色">
              <el-input v-model="form.color"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="色号" label-width="50px">
              <el-input v-model="form.colorNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="参照缸号" label-width="70px">
              <el-input v-model="form.demand"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="form.combine == '是'">
          <el-col :span="8">
            <el-form-item label="颜色">
              <el-input v-model="form.combineColor"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="色号" label-width="50px">
              <el-input v-model="form.combineColorNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="参照缸号" label-width="70px">
              <el-input v-model="form.combineDemand"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="订单数量">
              <el-input v-model="form.itemQuantity"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="投入数量">
              <el-input v-model="form.productQuantity"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="加工">
              <el-input v-model="form.process"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="计价方式">
              <el-select v-model="form.chargeMode" placeholder="请选择计价方式" style="width: 100%;">
                <el-option label="订单量" value="1"></el-option>
                <el-option label="投入量" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="单价">
              <el-input v-model="form.unitPrice"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="价格小计">
              <el-input v-model="form.price" @focus="calcPrice"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="交期">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="form.deliveryDate"
                value-format="yyyy-MM-dd"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="优先级">
              <el-select v-model="form.priority" placeholder="请选择优先级" style="width: 100%;">
                <el-option label="正常" value="1"></el-option>
                <el-option label="重要" value="2"></el-option>
                <el-option label="紧急" value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addOrderItem">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="修改订单子项" :visible.sync="updateDialogVisible" :width="dialogWidth">
      <el-form :model="form" :label-width="formLabelWidth">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="纱支">
              <el-input v-model="form.yarn"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否并线">
              <el-select v-model="form.combine" placeholder="请选择是否并线">
                <el-option label="是" value="是"></el-option>
                <el-option label="否" value="否"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row>
          <el-col :span="8">
            <el-form-item label="颜色">
              <el-input v-model="form.color"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="色号" label-width="50px">
              <el-input v-model="form.colorNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="参照缸号" label-width="70px">
              <el-input v-model="form.demand"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="form.combine == '是'">
          <el-col :span="8">
            <el-form-item label="颜色">
              <el-input v-model="form.combineColor"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="色号" label-width="50px">
              <el-input v-model="form.combineColorNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="参照缸号" label-width="60px">
              <el-input v-model="form.combineDemand"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="订单数量">
              <el-input v-model="form.itemQuantity"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="投入数量">
              <el-input v-model="form.productQuantity"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="加工">
              <el-input v-model="form.process"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="计价方式">
              <el-select v-model="form.chargeMode" placeholder="请选择计价方式" style="width: 100%;">
                <el-option label="订单量" value="1"></el-option>
                <el-option label="投入量" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="单价">
              <el-input v-model="form.unitPrice"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="价格小计">
              <el-input v-model="form.price" @focus="calcPrice"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="交期">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="form.deliveryDate"
                value-format="yyyy-MM-dd"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="优先级">
              <el-select v-model="form.priority" placeholder="请选择优先级" style="width: 100%;">
                <el-option label="正常" value="1"></el-option>
                <el-option label="重要" value="2"></el-option>
                <el-option label="紧急" value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="发货日期">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="form.dispatchDate"
                value-format="yyyy-MM-dd"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="物流编号">
              <el-input v-model="form.expressNo"></el-input>
            </el-form-item>
          </el-col>
        </el-row> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateOrderItem">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "OrderItemTable",
  props: {
    data: Object
  },
  data() {
    return {
      tableData: [],
      dialogWidth: "700px",
      formLabelWidth: "80px",
      dialogFormVisible: false,
      updateDialogVisible: false,
      form: {},
      show: true,
      index: 0
    };
  },
  methods: {
    toAddItems() {
      this.dialogFormVisible = true;
      //重置项目
      this.form = {
        yarn: this.form.yarn,
        combine: this.form.combine,
        process: this.form.process,
        chargeMode: this.form.chargeMode,
        deliveryDate: this.form.deliveryDate
      };
    },
    handleEdit(index, row) {
      console.log(index, row);
      this.index = index;
      this.updateDialogVisible = true;
      this.form = JSON.parse(JSON.stringify(row));
    },
    updateOrderItem() {
      this.tableData[this.index] = JSON.parse(JSON.stringify(this.form));
      this.updateDialogVisible = false;
      this.tableData.push({});
      this.tableData.pop();
    },
    handleDelete(index, row) {
      console.log(index, row);
      this.tableData.splice(index, 1);
    },
    addOrderItem() {
      this.tableData.push(JSON.parse(JSON.stringify(this.form)));
      this.dialogFormVisible = false;
    },
    calcPrice() {
      if (this.form.chargeMode == "1") {
        this.$set(
          this.form,
          "price",
          this.form.unitPrice * this.form.itemQuantity
        );
      } else if (this.form.chargeMode == "2") {
        this.$set(
          this.form,
          "price",
          this.form.unitPrice * this.form.productQuantity
        );
      }
    },
    priorityFormatter(row){
      if(row.priority == "1"){
        return "正常";
      }else if(row.priority == "2"){
        return "重要";
      }else if(row.priority == "3"){
        return "紧急";
      }
    }
  }
};
</script>

<style scoped>
.el-form-item {
  margin-bottom: 22px;
}
#items {
  margin-top: 5px;
}
</style>